// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

/* Custom styles */
.head_title{
    padding: 10px 5px;
    color: #fff;
}
.select_cat {

        padding: 10px 17px;
    color: #888;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB,kBAAkB;AAClB;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;;QAEQ,kBAAkB;IACtB,WAAW;IACX,kBAAkB;AACtB","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n/* Custom styles */\r\n.head_title{\r\n    padding: 10px 5px;\r\n    color: #fff;\r\n}\r\n.select_cat {\r\n\r\n        padding: 10px 17px;\r\n    color: #888;\r\n    border-radius: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
